export default __webpack_public_path__ + "static/media/3.5a98cf8e.jpg";